// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table_date_decor {\n  cursor: pointer;\n  text-decoration: underline;\n  color:rgb(43, 95, 226);\n}", ""]);
// Exports
module.exports = exports;
